import React, { useEffect, useState } from "react";
import Input from "../../../Components/Input/Input";
import { getViewCountry, UpdateCountry } from "../../../utils/api";
import { useParams } from "react-router-dom";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp";

const ViewCountryDetails = () => {
  const { id } = useParams();
  const [viewHotelData, setViewHotelData] = useState({});
  const [errors, setErrors] = useState({});
const [message,setMessage] = useState("");

  const viewHotel = () => {
    const param = id ;
    getViewCountry(param).then((response) => {
      setViewHotelData(response?.data?.data || {});
    });
  };

  useEffect(() => {
    viewHotel();
  }, []);

  const validateFields = () => {
    let isValid = true;
    const newErrors = {};

    if (!viewHotelData.name || viewHotelData.name.trim() === "") {
      newErrors.name = "Country name is required.";
      isValid = false;
    }

    if (!viewHotelData.iso2 || viewHotelData.iso2.trim() === "") {
      newErrors.iso2 = "ISO2 code is required.";
      isValid = false;
    }

    if (!viewHotelData.iso3 || viewHotelData.iso3.trim() === "") {
      newErrors.iso3 = "ISO3 code is required.";
      isValid = false;
    }

    if (!viewHotelData.phoneCode || viewHotelData.phoneCode.trim() === "") {
      newErrors.phoneCode = "Phone code is required.";
      isValid = false;
    }

    if (viewHotelData.active === undefined || viewHotelData.active === "") {
      newErrors.active = "Status is required.";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleUpdate = () => {
    if (validateFields()) {
      const param = { id, ...viewHotelData };
      UpdateCountry(param).then((resp) => {
        if(resp){
            setMessage("Country updated successfully!");
        }
        
      }).catch(() => {
        setMessage("Failed to update country.");
      });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setViewHotelData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (



    <div className="main_container">
       <div className="userlist_head mb-5">

     <div className="userlist_heading">
        <div className="userlist_left">
          <label>Country details</label>
        </div>
</div>
        </div>

     <div>
      <div className="subadmin_container justify-between flex column gap-20" style={{padding:"30px"}} >
       <div style={{flex:"1 1 100%"}}>
          <div className="flex gap-10">
            <div style={{flex:"1 1 50%"}}>
              <div className="labelname mb-5">
                <label className="fw-bold">Country Name:</label>
              </div>
              <Input
                type="text"
              
                placeholder="Country Name"
                name="name"
                value={viewHotelData?.name || ""}
                onChange={handleInputChange}
              />
              {errors.name && <p className="error fs-12 mt-10">{errors.name}</p>}
            </div>

            <div className="input-field" style={{flex:"1 1 50%"}}>
              <div className="labelname mb-5">
                <label className="fw-bold">Status:</label>
              </div>
              <select
                style={{ width: "330px" }}
                className="input_select_field"
                name="active"
                value={viewHotelData?.active || ""}
                onChange={handleInputChange}
              >
                <option value="">Select Status</option>
                <option value={true}>ACTIVE</option>
                <option value={false}>INACTIVE</option>
              </select>
              {errors.active && <p className="error fs-12 mt-10">{errors.active}</p>}
            </div>
          </div>

          <div className="flex gap-10 mt-20">
            <div style={{flex:"1 1 50%"}}>
              <div className="labelname mb-5">
                <label className="fw-bold">Iso2:</label>
              </div>
              <Input
                type="text"
                maxLength={10}
                placeholder="Iso2"
                name="iso2"
                value={viewHotelData?.iso2 || ""}
                onChange={handleInputChange}
              />
              {errors.iso2 && <p className="error fs-12 mt-10">{errors.iso2}</p>}
            </div>

            <div style={{flex:"1 1 50%"}}>
              <div className="labelname mb-5">
                <label className="fw-bold">Iso3:</label>
              </div>
              <Input
                type="text"
                maxLength={10}
                placeholder="Iso3"
                name="iso3"
                value={viewHotelData?.iso3 || ""}
                onChange={handleInputChange}
              />
              {errors.iso3 && <p className="error fs-12 mt-10">{errors.iso3}</p>}
            </div>
          </div>

          <div className="mt-20">
            <div className="labelname mb-5">
              <label className="fw-bold">Phone Code:</label>
            </div>
            <Input
              type="text"
              maxLength={10}
              placeholder="Phone Code"
              name="phoneCode"
              value={viewHotelData?.phoneCode || ""}
              onChange={handleInputChange}
            />
            {errors.phoneCode && <p className="error fs-12 mt-10">{errors.phoneCode}</p>}
          </div>
        </div>

        <div>
          <button onClick={handleUpdate} className="userlist_btn">
            Update Country
          </button>
        </div>
      </div>
   
   
    </div>

    </div>
  );
};

export default ViewCountryDetails;
